import { mergeDeepRight } from 'ramda';
import globalConfig from '../config';

const { host, protocol } = window.location;
const { IN_PRODUCTION } = globalConfig;

interface DatevConfig {
  datevServiceApi: string;
  appDetails: {
    redirectUrl: string;
  };
  datevSubscription: string;
}

const localConfig: DatevConfig = {
  datevServiceApi:
    (IN_PRODUCTION && 'https://datev-prod.inventorum.com/api') ||
    'https://datev-aws.inventorum.com/api',
  appDetails: {
    redirectUrl: `${protocol}//${host}/integrations/datev/callback`,
  },
  datevSubscription: 'Datev',
};

export default mergeDeepRight(globalConfig, localConfig);
